module.exports = __webpack_public_path__ + "img/logo.d73026d2.png";